export const MENU_SET_ITEMS = 'Set menu items';
export const MENU_SELECT_ITEM = 'Select menu item';
export const MENU_DESELECT_ITEM = 'De-select menu item';
export const MENU_UPDATE_SELECTED_ITEM_QUANTITY = 'Update selected item quantity';
export const MENU_UPDATE_SELECTED_ITEM_OPTION = 'Update selected item option';

export const BASKET_ITEM_ADD = 'Add item to basket';
export const BASKET_ITEM_REMOVE = 'Remove item from basket';
export const BASKET_ITEM_UPDATE = 'Update basket item';
export const BASKET_ITEM_UPDATED = 'Updated basket item';
export const BASKET_EMPTY = 'Empty basket';
export const BASKET_SAVE = 'Save basket';
export const BASKET_SET_ITEMS = 'Set basket items';
export const ORDER_SUCCESS = 'Order success';
export const ORDER_NAME = 'Order name';

export const COOKIES_ACCEPTED = 'Cookies accepted';

export const TRACK_AND_TRACE_ACCEPTED = 'Track and trace accepted';
